import React from 'react'
import { Fragment } from 'react'
import { Link } from "react-router-dom";
import NumberFormat from 'react-number-format';
import { useTranslation } from '../hooks/useTranslation';

function ProductBoxComponent({ idx, lang, prod, chainId, selectProd, companyUser, getProductTranslations }) {
    const { t } = useTranslation();

    const currencySymbol = prod.currencyCode.replace("ILS", "₪").replace("USD", "$");

    const getPriceAfterDiscount = () => {
        return Math.ceil(prod.productPriceAfterDiscount) ?? Math.ceil(prod.productPrice);
    }
    return (
        <Fragment>
            <h2
                className="name"
                tabIndex={!!idx == 0 ? "0" : ""}
                aria-label={getProductTranslations(prod).productName
                    ? getProductTranslations(prod).productName
                    : prod.productName}
                dangerouslySetInnerHTML={{
                    __html: getProductTranslations(prod).productName
                        ? getProductTranslations(prod).productName
                        : prod.productName
                }}
            ></h2>
            <div
                className="descr"
                role="application"
                aria-roledescription={t("Description")}
                aria-label={getProductTranslations(prod).productShortDescription}
                dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productShortDescription }}
            ></div>
            <div className="prod-box-bottom d-flex justify-content-between">
                <div
                    className="price"
                    role="application"
                    aria-roledescription={t("Price")}
                    aria-label={getPriceAfterDiscount()}
                >
                    <NumberFormat
                        value={getPriceAfterDiscount()}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={currencySymbol}
                    />
                    {
                        (prod?.productPrice > prod?.productPriceAfterDiscount) && !companyUser &&
                        <div className='old-price'>
                            <span>{t('InsteadOf')}</span>
                            &nbsp;
                            <NumberFormat
                                value={prod.productPrice}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                            />
                        </div>
                    }
                </div>
                <Link
                    onClick={e => selectProd(prod)}
                    className="btn"
                    aria-label={`${t("MoreInfAndRsv")} ${getProductTranslations(prod).productName}`}
                    to={`/product?chainid=${chainId}&pid=${prod.productId}&lang=${lang}`}
                >
                    {t("MoreInfAndRsv")}
                </Link>
            </div>
        </Fragment>
    )
}

export default ProductBoxComponent;